import React, { Component } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import EditFactTypeForm from '../components/EditFactTypeForm';
import axios from 'axios';
import { Panel, Col, Row, Button, FormControl, Form } from 'react-bootstrap';
import PlainPanel from '../components/PlainPanel';
import config from '../config';
import qs from 'qs';
import { Link } from 'react-router-dom';

import './EditFactType.css';

class EditFactType extends Component {
    constructor(props) {
        super(props);

        this.state = { facttype: { description: '', enabled: false } };
    }

    componentDidMount() {
        this.loadFactTypeFromServer();
    }

    loadFactTypeFromServer() {
        const { facttypeID } = this.props.match.params;

        var self = this;
        axios
            .get(`${config.baseURL}/facttypes/${facttypeID}`, {})
            .then(function(response) {
                self.setState({ facttype: response.data.factType });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    render() {
        const { t } = this.props;
        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;
        document.title = `MySign Digital Screen Solutions | ${t(
            'EditFactType.title'
        )}`;

        return (
            <div className="EditFactType">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('EditFactType.title')}
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-info" />{' '}
                                        <Link to={`/facts`}>
                                            {t('Facts.title')}
                                        </Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-list" />{' '}
                                        <Link to={`/facts/facttypes`}>
                                            {t('FactTypes.title')}
                                        </Link>
                                    </li>
                                    <li className="active">
                                        <i className="fas fa-pencil-alt" />{' '}
                                        {t('EditFactType.title')}
                                    </li>
                                </ol>

                                <PlainPanel>
                                    <EditFactTypeForm
                                        facttype={this.state.facttype}
                                    />
                                </PlainPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(EditFactType);
